function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useCallback, useMemo, useRef } from 'react';
import { useControlledState } from '@react-stately/utils';
import { itemSelectionToStringSet } from "../utils/index.js";
import { resolveSelection } from "./multiSelectUtils.js";
export function useMultiSelectState(_ref) {
  var propSelectedKeys = _ref.selectedKeys,
    defaultSelectedKeys = _ref.defaultSelectedKeys,
    propDisabledKeys = _ref.disabledKeys,
    propOnChange = _ref.onChange,
    propOnSelectionChange = _ref.onSelectionChange,
    allKeys = _ref.allKeys;
  var controlledKeys = useMemo(() => propSelectedKeys !== undefined ? resolveSelection(propSelectedKeys, allKeys) : undefined, [propSelectedKeys, allKeys]);
  var handleChange = useCallback(next => {
    var callback = propOnChange !== null && propOnChange !== void 0 ? propOnChange : propOnSelectionChange;
    callback === null || callback === void 0 || callback(next);
  }, [propOnChange, propOnSelectionChange]);

  // Resolve the initial default once. useControlledState only reads this on
  // first render in uncontrolled mode and ignores it in controlled mode, so
  // recomputing on every render would just allocate a throwaway Set.
  var initialDefaultRef = useRef(undefined);
  if (initialDefaultRef.current === undefined) {
    initialDefaultRef.current = resolveSelection(defaultSelectedKeys, allKeys);
  }
  var _useControlledState = useControlledState(controlledKeys, initialDefaultRef.current, handleChange),
    _useControlledState2 = _slicedToArray(_useControlledState, 2),
    selectedKeys = _useControlledState2[0],
    setSelectedKeys = _useControlledState2[1];

  // Mirror selectedKeys into a ref so toggleKey/applyListBoxSelection can
  // read the latest value without re-creating on every change.
  var selectedKeysRef = useRef(selectedKeys);
  selectedKeysRef.current = selectedKeys;
  var listBoxDisabledKeys = useMemo(() => itemSelectionToStringSet(propDisabledKeys), [propDisabledKeys]);
  var toggleKey = useCallback(key => {
    var next = new Set(selectedKeysRef.current);
    if (next.has(key)) {
      next.delete(key);
    } else {
      next.add(key);
    }
    setSelectedKeys(next);
  }, [setSelectedKeys]);
  var applyListBoxSelection = useCallback((selection, filteredItems) => {
    if (selection === 'all') {
      setSelectedKeys(new Set(allKeys));
      return;
    }

    // Preserve selected keys for items not in the current filtered list.
    // The ListBox only knows about rendered (filtered) items, so it can't
    // manage selection state for items hidden by search filtering.
    var filteredKeySet = new Set(filteredItems.map(i => i.key));
    var next = new Set([...selectedKeysRef.current].filter(k => !filteredKeySet.has(k)));
    selection.forEach(k => next.add(String(k)));
    setSelectedKeys(next);
  }, [allKeys, setSelectedKeys]);
  var selectedKeyArray = useMemo(() => [...selectedKeys], [selectedKeys]);
  return {
    selectedKeys,
    selectedKeyArray,
    listBoxDisabledKeys,
    toggleKey,
    applyListBoxSelection
  };
}
export default useMultiSelectState;
//# sourceMappingURL=useMultiSelectState.js.map